// Version 1.0.0, created for kuoni.ch
//
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Select } from './mdb/mdb-select';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import SimpleLightbox from 'simplelightbox';

type MdbSelectEvent = Event & {value: string};
type MdbSelectElement = Element & {kuoniSolrSelectEventsInitialized?: boolean};

export class SearchController {
    protected ajaxType: number = 7383;
    protected selector: string = 'a.solr-ajaxified';

    protected lang: string = 'de';
    protected labels: Labels = {
        de: {
            mdbOptionsSelectedLabel: ' ausgewählt',
            mdbSearchPlaceholder: 'Suchen...'
        },
        fr: {
            mdbOptionsSelectedLabel: ' sélectionnés',
            mdbSearchPlaceholder: 'Rechercher...'
        }
    };

    constructor (language: string, ajaxType?:number, selector?:string) {
        this.lang = language;
        if (ajaxType) {
            this.ajaxType = ajaxType;
        }
        if (selector) {
            this.selector = selector;
        }
        this.init();
    }

    protected scrollTo (element: Element, to: number, duration: number):void {
        if (duration <= 0) return;
        const difference = to - element.scrollTop;
        const perTick = difference / duration * 10;

        setTimeout(() => {
            element.scrollTop = element.scrollTop + perTick;
            if (element.scrollTop === to) return;
            this.scrollTo(element, to, duration - 10);
        }, 10);
    }

    protected getOffsetTop (element: HTMLElement): number {
        return element ? (element.offsetTop + this.getOffsetTop(<HTMLElement>element.offsetParent)) : 0;
    }

    protected getAjaxUri (uri: string): URL {
        const ajaxUri = new URL(uri, window.location.protocol + '//' + window.location.host);
        ajaxUri.searchParams.append('type', `${this.ajaxType}`);
        return ajaxUri;
    }

    protected initMdbSelects (): void {
        const selectFields = Array.from(document.getElementsByClassName('mdb-select-filter'));
        for (const item of selectFields) {
            this.initMdbSelect(item, {
                optionsSelectedLabel: this.labels[this.lang].mdbOptionsSelectedLabel,
                searchPlaceholder: this.labels[this.lang].mdbSearchPlaceholder
            });
        }

        const selectMultiFields = Array.from(document.getElementsByClassName('mdb-multiselect-filter'));
        for (const item of selectMultiFields) {
            this.initMdbSelect(item, {
                displayedLabels: 2,
                optionsSelectedLabel: this.labels[this.lang].mdbOptionsSelectedLabel,
                searchPlaceholder: this.labels[this.lang].mdbSearchPlaceholder
            });
        }
    }

    protected initMdbSelect (item: Element, options: object): void {
        const select = <MdbSelectElement>item;

        if (!Select.getInstance(item)) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const selectField = new Select(item, options);
        }

        if (select.kuoniSolrSelectEventsInitialized) {
            return;
        }

        select.addEventListener('optionSelect.mdb.select', function (element) {
            const myElem = <MdbSelectEvent>element;
            window.searchController.handleSelectOptionSelection(<HTMLSelectElement>element.target, myElem.value);
        });
        select.addEventListener('optionDeselect.mdb.select', function (element) {
            const myElem = <MdbSelectEvent>element;
            window.searchController.handleSelectOptionSelection(<HTMLSelectElement>element.target, myElem.value);
        });
        select.kuoniSolrSelectEventsInitialized = true;
    }

    protected initLightBox (): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-call
        const lightbox = new SimpleLightbox('.img-gallery a', { overlayOpacity: 0.85, captionSelector: 'self' });
    }

    protected fetchData (uri: string, solrContainer: HTMLElement): boolean {
        // show loading animation
        const solrLoading = <HTMLElement>solrContainer.querySelector('.solr-loading');
        if (solrLoading) {
            solrLoading.style.display = 'block';
        }
        // get parent element
        const solrParent = <HTMLElement>solrContainer.parentElement;

        fetch(uri)
            .then((response) => {
                return response.text();
            })
            .then((data) => {
                if (data) {
                    // replace solr plugin content
                    solrContainer.outerHTML = data;

                    this.initMdbSelects();
                    this.initLightBox();

                    // scroll to top
                    if (solrParent) {
                        this.scrollTo(document.documentElement, this.getOffsetTop(solrParent), 600);
                    }
                }
                return true;
            })
            .catch((err) => {
                console.warn(err);
            });
        return true;
    }

    handleSelectOptionSelection (elem: HTMLSelectElement, value: string): void {
        // close select dropdown
        const selectField = <Select>Select.getInstance(elem);
        selectField.close();

        const solrContainer = <HTMLElement>elem.closest('.tx_solr');
        if (!solrContainer) {
            return;
        }
        // filter usage tracking
        if (typeof window.dataLayer !== 'undefined' && elem.id) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            window.dataLayer.push({ event: 'custom_event', custom_event_data: { event_type: 'filter_results', filter_type: elem.id } });
        }
        const ajaxUri = this.getAjaxUri(value);
        this.fetchData(ajaxUri.toString(), solrContainer);
    }

    init ():void {
        // FITYMI hack: check for new offer layout
        const newResultsLayoutCheck = document.querySelector('.tx-solr-newresults');
        if (newResultsLayoutCheck) {
            this.ajaxType = 7393;
        }

        this.initMdbSelects();

        const body = document.querySelector('body');
        if (!body) {
            return;
        }
        body.addEventListener('click', (e) => {
            let target = <HTMLElement>e.target;
            if (!target || !target.closest(this.selector)) {
                return;
            }
            e.preventDefault();
            if (target.tagName !== 'A') {
                target = <HTMLElement>target.closest(this.selector);
            }

            const solrContainer = <HTMLElement>target.closest('.tx_solr');
            if (!solrContainer) {
                return;
            }

            const uri = target.getAttribute('href');
            if (!uri) {
                return;
            }

            const ajaxUri = this.getAjaxUri(uri);
            this.fetchData(ajaxUri.toString(), solrContainer);
        });
    }
}
